export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT_SUCCES = 'LOGOUT_SUCCES'
export const GET_MENUS_SUCCESS = 'GET_MENUS_SUCCESS'
export const LOGIN_SUCCESS_AD = 'LOGIN_SUCCESS_AD'
export const CHANGE_USERSCHOOL = 'CHANGE_USERSCHOOL'
export const SHOW_VERITY = 'SHOW_VERITY'